import { Column, Box, styled } from 'shared/Houston';

import { css } from '@eduzz/houston-styles/styled';

export const Paper = styled(Box)`
  border: ${({ theme }) => `1px solid ${theme.neutralColor.high.medium}`};
`;

export const ContainerAction = styled(Column)`
  ${({ theme }) => css`
    @media only screen and (max-width: ${theme.breakpoints.md}) {
      && {
        padding-top: 0;
      }
    }
  `}
`;
